import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../../lib/auth.context'
import { supabase } from '../../lib/supabase'
import { useToast } from '../../hooks/use-toast'
import { TOTPVerify } from '../../components/auth/totp-verify'
import { TOTPEnrollment } from '../../components/auth/totp-enrollment'
import { LoginForm } from '../../components/auth/login-form'
import Background from '../../components/background'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [formError, setFormError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [showTOTPVerify, setShowTOTPVerify] = useState(false)
  const [showTOTPEnroll, setShowTOTPEnroll] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()
  const { toast } = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setFormError('')
    setIsLoading(true)
    try {
      await login(email, password)

      // Always check for MFA factors after successful password authentication
      const { data: factors } = await supabase.auth.mfa.listFactors()

      console.log('[Login] Password authentication successful, checking TOTP factors:', factors)

      if (factors?.totp && factors.totp.length > 0) {
        // User has TOTP set up, ALWAYS require verification regardless of AAL
        console.log('[Login] TOTP factor found, requiring verification')
        setShowTOTPVerify(true)
      } else {
        // User needs to set up TOTP first
        console.log('[Login] No TOTP factor found, requiring enrollment')
        setShowTOTPEnroll(true)
      }

      // Never redirect directly - always require MFA verification/enrollment
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to login'
      setFormError(errorMessage)
      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    // <Background>
    <div className="flex min-h-screen items-center justify-center">
      {showTOTPVerify ? (
        <TOTPVerify />
      ) : showTOTPEnroll ? (
        <TOTPEnrollment />
      ) : (
        <div className="w-full">
          <LoginForm
            setEmail={setEmail}
            setPassword={setPassword}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            formError={formError}
          />
        </div>
      )}
    </div>
    // </Background>
  )
}
